import { render, staticRenderFns } from "./wyflist.vue?vue&type=template&id=408736db&"
import script from "./wyflist.vue?vue&type=script&lang=js&"
export * from "./wyflist.vue?vue&type=script&lang=js&"
import style0 from "./wyflist.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports